export const OPEN_RIGHTMENU = 'OPEN_RIGHTMENU';
export const CLOSE_RIGHTMENU = 'CLOSE_RIGHTMENU';
export const TOGGLE_RIGHTMENU = 'TOGGLE_RIGHTMENU';
export function setRightMenu(open) {
    return {
        type: open ? OPEN_RIGHTMENU : CLOSE_RIGHTMENU,
    };
}
export function toggleRightMenu() {
    return {
        type: TOGGLE_RIGHTMENU,
    };
}
